<script>
import { BBreadcrumb } from 'bootstrap-vue'

export default {
  name: 'AppHeader',
  
  components: {
    BBreadcrumb
  },
  
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col">
        <b-breadcrumb :items="items" class="mb-0 font-size-12"></b-breadcrumb>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col d-flex align-items-end">
        <div>
          <span class="mb-0 font-size-22 fw-semibold">{{ title }}</span>
        </div>
      </div>

      <div class="col">
        <div class="d-flex justify-content-end align-items-center pb-1">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>